import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { ItemTemplateEntity } from '@/types/api';

export const getItemTemplates = async (orgId: string): Promise<ItemTemplateEntity[]> => {
  const { data } = await api.get<undefined, ApiResponse<ItemTemplateEntity[]>>(
    `/orgs/${orgId}/item-templates`,
  );
  return data;
};

export const getItemTemplatesQueryKey = (orgId?: string) => {
  const queryKey = ['item-templates'];
  if (orgId) queryKey.push('org', orgId);
  return queryKey;
};

export const getItemTemplatesQueryOptions = (orgId: string) => {
  return queryOptions({
    queryKey: getItemTemplatesQueryKey(orgId),
    queryFn: () => getItemTemplates(orgId),
    enabled: !!orgId,
  });
};

interface UseItemTemplatesOptions {
  orgId?: string;
  queryConfig?: QueryConfig<typeof getItemTemplatesQueryOptions>;
}

export const useItemTemplates = ({ queryConfig }: UseItemTemplatesOptions = {}) => {
  const { orgId } = useScopeIds('org');
  return useQuery({
    ...getItemTemplatesQueryOptions(orgId),
    ...queryConfig,
  });
};
